import { Injectable} from '@angular/core';
import { Observable} from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private urlAyudaLogin = environment.urlAyudaLogin;
  private urlAutenticar = environment.urlAutenticar;
  private urlAutenticarFr = environment.urlAutenticarFr;
  private urlAutenticarFrIca = environment.urlAutenticarFrIca;
  
  constructor(private http: HttpClient) {}

  ayudaLogin(): Observable<any> {
    const authHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8')
    const httpOptions = { headers: authHeaders};
    if(environment.production == false && environment.proxyOfinaVirtual != null){
      this.urlAyudaLogin = this.urlAyudaLogin.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual)
    }
    return this.http.post(`${this.urlAyudaLogin}`, {}, httpOptions);
  }


  autenticarse(data: string): Observable<any> {
    const authHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json;charset=UTF-8')
    const httpOptions = { headers: authHeaders};
    let url = this.urlAutenticar;
    if(environment.production == false && environment.proxyOfinaVirtual != null){
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual)
    }
    return this.http.post(`${url}`, {data}, httpOptions);
  }

  autenticarseParaFirmar(data: string): Observable<any> {
    const authHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json;charset=UTF-8')
    const httpOptions = { headers: authHeaders};
    let url = this.urlAutenticarFr;
    if(environment.production == false && environment.proxyOfinaVirtual != null){
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual)
    }
    return this.http.post(`${url}`, {data}, httpOptions);
  }


  registrarFirma(data: any): Observable<any> {

    const authHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8')
    const httpOptions = { headers: authHeaders };
    let url = this.urlAutenticarFrIca;
    if(environment.production == false && environment.proxyOfinaVirtual != null){
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual)
    }
    return this.http.post(`${url}`, data, httpOptions);
  }

}
